import style from "./needhelp.module.css";


const Payout = () => {
  return (
    <div className={style.content}>
      <div className={`p-3 bg-white rounded ${style.articleScroll}`}>
        <div className="">
          <div className=" fw-bold">
            Understanding Payouts: Your Guide to Accessing Funds on GiveSendGo
          </div>
          <div className=" mt-2 fs14 ">
            Only verified recipients can request payouts. It's important to
            designate who will manage the funds.
          </div>
          <ul className="mt-2">
            <li className="fs14">
              For a guide on adding a recipient and completing verification,
              see: How to Add a Recipient and Receive Funds.
            </li>
            <li className="fs14">
              Once you've been added as a recipient, here's how to enter your
              banking details: How to Add Your Bank Details as a Recipient.
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">Verification Requirements</div>
          <div className="fs14 mt-2">
            To successfully verify the recipient's identity, the following are
            required:
          </div>
          <ul className="mt-2">
            <li className="fs14">
              A bank account (in the same currency as the fundraiser)
            </li>
            <li className="fs14">A passport or government-issued photo ID</li>
            <li className="fs14">A phone number</li>
            <li className="fs14">
              A residential address (PO boxes are not accepted)
            </li>
            <li className="fs14">
              A tax ID (for example, a Social Security Number if in the US)
            </li>
            <li className="fs14">
              The recipient must be 18 years of age or older
            </li>
          </ul>

          <div className="fs14 mt-3">
            Note: The verification process is mandatory as it complies with
            financial regulations and ensures secure transactions.
          </div>
          <div className="fs14 mt-3">
            After you complete these steps, your campaign will undergo a
            verification review, usually within 48 hours. We might contact you
            for additional information if needed. Once verified,
            the 'Payouts' section becomes available in your Campaign Dashboard,
            ready for payout management.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Automatic Payouts</div>
          <ul className="mt-2">
            <li className="fs14">
              Note: As of November 21st, 2023, the option for Automatic Payouts
              is available exclusively for campaigns created on or after this
              date. For campaigns initiated before November 21st, 2023, only
              Manual Payouts will be available.
            </li>
            <li className="fs14">
              Convenience: Funds are sent directly to your bank account
              according to the schedule you set.
            </li>
            <li className="fs14">
              Frequency: Choose from options like weekly, bi-weekly, or monthly
              during setup
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">Manual Payouts</div>
          <ul className="mt-2">
            <li className="fs14">
              Control: You decide when to withdraw your funds by requesting a
              payout manually.
            </li>
            <li className="fs14">
              Request: Use the ‘Send Payout Request’ button when it's active.
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <div className=" text-black">Switching Between Modes: </div>
          <div className="fs14 mt-2">
            You can switch between automatic and manual payout requests at any
            time. Note that the first automatic request will occur seven days
            after saving your preference when switching from manual to
            automatic.
          </div>
        </div>

        <div className="mt-4">
          <div className=" text-black">Processing and Payout Times</div>
          <ul className="mt-2">
            <li className="fs14">
              Initial Payout: Available 5 days after your campaign's first
              successful donation.
            </li>
            <li className="fs14">
              Subsequent Donations: Each donation is processed within 3 days and
              made available for payout. Please note, while most donations are
              processed in this standard timeframe, some larger or high-risk
              donations may require additional processing time
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <div className=" text-black">Payout Requests</div>
          <ul className="mt-2">
            <li className="fs14">
              Automatic: No request needed; payouts follow your schedule.
            </li>
            <li className="fs14">
              Manual: Submit new requests 24 hours after your last payout
              approval.
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">
            Partial Payout Requests (Manual Only) 
          </div>
          <div className="fs14 mt-2">
            If you need a specific amount, contact us before making your payout
            request.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Deposit Timeframe</div>
          <div className="fs14 mt-2">
            Funds typically deposit within 2-3 business days after processing.
          </div>
          <ul className="mt-2">
            <li className="fs14">
              Please note, for non-USD payouts, the deposit may take longer due
              to international processing times.
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">Fees  </div>
          <div className="fs14 mt-2">
            GiveSendGo is free to use, with only standard processing fees
            applied per donation. Learn about processing fee rates so you can
            plan your campaign effectively.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Minimum Payout Requirements</div>
          <div className="fs14 mt-2">
            If a payout is unavailable, please check the Minimum payout amount
            requirement for your country on this page,
            here: https://www.givesendgo.com/Pricing-and-Fees
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Recipient Types and Verification</div>
          <ul className="mt-2">
            <li className="fs14">
              Individuals: Require ID verification and bank information.
            </li>
            <li className="fs14">
              Organizations/Non-Profits: Legal Representatives must provide ID
              verification, EIN, and official bank information. Additional
              documents like business registration may be needed.
            </li>
            <li className="fs14">
              Businesses: Similar requirements as organizations/non-profits.
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">Additional Information</div>
          <div className="fs14 mt-2">
            We may request further documentation to fulfill legal requirements
            and ensure compliance with our platform's policies.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Still need help?</div>
          <div className="fs14 mt-2">
            Click the Contact Us button at the bottom right of the page to reach
            out to our team. We’re here to help guide you through the process.  
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payout;
